import { AvailableProposal } from "../../types/loan-application";

export default function useMockMotonovoProposal(price: number) {
  const proposal = {} as AvailableProposal;

  proposal.proposalId = Number(10101);
  proposal.lenderReference = 'MOTONOVO_REF';
  proposal.isPrime = true;
  proposal.isPreferredAcceptance = true;
  proposal.minVehicleAgeAtStart = null;
  proposal.maxVehicleAgeAtStart = null;
  proposal.maxVehicleAgeAtEnd = 15;
  proposal.minMileage = null;
  proposal.maxMileage = Number(130000);
  proposal.maxLendAmount = Number(75000);
  proposal.minLendAmount = Number(3000);
  proposal.minLendAmountPcp = Number(3000);
  proposal.minTerm = Number(36);
  proposal.maxTerm = Number(60);
  proposal.loanProposalStatus = "ProvisionalAcceptance";

  proposal.amountToFinance = Number(price);
  proposal.apr = null;
  proposal.flatRate = null;
  proposal.financeCompany = "Motonovo";
  proposal.financeCompanyId = 67;

  proposal.rank = null;

  return proposal;
}

